<template>
  <SurveyForm
    @on-submit-edit="editSurvey"
    ref="surveyForm"
    :isEditPage="true"
  />
</template>
<script>
import SurveyForm from "./SurveyForm.vue";
import { Message } from "@/helpers/utils";
import { service_names } from "@/constants/Services";
import { survey_router_names } from "@/routes/routes";

export default {
  components: {
    SurveyForm
  },
  data() {
    return {
      isChildComponentLoaded: false
    };
  },
  computed: {
    surveyId() {
      return this.$route.params.id;
    }
  },
  methods: {
    editSurvey(dataSurvey) {
      this.$axios
        .put(`${service_names.school}/survey/${this.surveyId}`, dataSurvey)
        .then(() => {
          Message.success(this.$t("common.edit_success"));
          this.$router.push({ name: survey_router_names.listPage });
        });
    }
  }
};
</script>
